<app-header [forceLightBackground]="true"></app-header>
<div class="org-admin-my-request">
  <div class="org-admin-my-request--layout">
    <app-org-admin-sidebar class="org-admin-my-request--sidebar"></app-org-admin-sidebar>
    <div class="org-admin-my-request--content">
      <app-page-header></app-page-header>
      <div class="my-request-container">
        <div class="tabs-container">
          <div class="tabs-header">
            <div class="tabs-header__tabs">
              <button
                *ngIf="showMyRequestsTab"
                class="tab-button"
                [class.active]="activeTab === 'myRequests'"
                (click)="setActiveTab('myRequests')"
              >
                My Requests
              </button>
              <button
                class="tab-button"
                [class.active]="activeTab === 'createdPolicies'"
                (click)="setActiveTab('createdPolicies')"
              >
                Granted Access
              </button>
              <button
                *ngIf="showAssetFeedbackTab"
                class="tab-button"
                [class.active]="activeTab === 'assetFeedback'"
                (click)="setActiveTab('assetFeedback')"
              >
                Asset Feedback
              </button>
            </div>
            <p
              class="access-request-note"
              *ngIf="activeTab === 'myRequests'"
              title="Approved requests will be shown in Granted Access Tab."
            >
              Approved requests will be shown in Granted Access Tab.
            </p>
          </div>

          <div class="tab-content-wrapper">
            <div class="tab-content" *ngIf="activeTab === 'myRequests'">
              <app-my-request-shared conversationRoute="/org-admin/requests"></app-my-request-shared>
            </div>

            <div class="tab-content" *ngIf="activeTab === 'createdPolicies'">
              <app-granted-access-panel policyPortal="org-admin"></app-granted-access-panel>
            </div>

            <div class="tab-content" *ngIf="showAssetFeedbackTab && activeTab === 'assetFeedback'">
              <app-consumer-asset-feedback panel="owner"></app-consumer-asset-feedback>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
